import AlertHexagonIcon from "@redotech/redo-icons/alert-hexagon.svg";
import { BlockCheckoutStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Handle, Position } from "@xyflow/react";
import { memo } from "react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";
import * as css from "./node.module.css";

export interface BlockCheckoutNodeData {
  step: PartialWithRequiredType<BlockCheckoutStep>;
  deleteElements: (id: string) => void;
  readonly: boolean;
}

export const BlockCheckoutNode = memo(function BlockCheckoutNode({
  id,
  data,
  selected,
}: {
  id: string;
  data: BlockCheckoutNodeData;
  selected?: boolean | undefined;
}) {
  return (
    <Flex dir="column" gap="md">
      <BaseNode
        containerClassName={css.checkoutNode}
        icon={
          <RedoFeaturedIcon color="error" Icon={AlertHexagonIcon} size="sm" />
        }
        onDelete={data.readonly ? undefined : () => data.deleteElements(id)}
        selected={selected}
        step={data.step}
        title="Block checkout"
      >
        <Handle id="top" position={Position.Top} type="target" />
      </BaseNode>
    </Flex>
  );
});
